import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

import { NavLink, useLocation, useParams, useSearchParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
// import VideoGlobal from '../global/VideoGlobal';
import Main from '../../pages/user/video/Main';
import VideoHighWide from '../../pages/user/video/VideoHighWide';
import Long from '../../pages/user/video/Long';
import Favorites from '../../pages/user/video/Favorites';
import { ModalForAll } from '../global/ModalForAll';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import DinamicTarea from '../global/DinamicTarea';
import PictureIcon from '../../svg/PictureIcon';
import ButtonLoader from '../global/ButtonLoader';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCutIcon from '@mui/icons-material/ContentCut';

import WaveSurfer from "wavesurfer.js";
import Slider from '@rc-component/slider';
import '@rc-component/slider/assets/index.css';

import CallApi from '../../data/CallApi';
import { ImagenesGlobal } from '../global/ImagenesGlobal';
import Note from '../../svg/Note';
import { debounce } from 'lodash';

import { Preloader } from '../Preloader';
import { VideoViewer } from './VideoViewer';
import { useProovedorData } from '../providers/ProovedorData';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

const UserSubNavbar = () => {
  const locationReact = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { userVideos } = useProovedorData() ?? [];
  const userKey = searchParams.get("authCode");

  const { view } = useParams();

  const [modalState, setModalState] = useState(false);

  const [mode, setMode] = useState(false);
  const [rangeEdit, setRangeEdit] = useState([0, 100]);

  const [uploadState, setUploadState] = useState(false);
  const [subModal, setSubModal] = useState(false);
  const [audioList, setAudioList] = useState([]);

  const [loadState, setLoadState] = useState({
    audio: false,
    upload: false
  });

  const inputVideo = useRef(null);
  const inputAudio = useRef(null);
  const videoRef = useRef(null);

  const containerRef = useRef(null);
  const waveSurferRef = useRef(null);

  const audioContextRef = useRef(null);
  const gainNodeRef = useRef(null);

  const resultsAudio = useRef({});


  const playVideo = () => {
    const videoR = videoRef.current;
    const wavesurfer = waveSurferRef.current;

    setGlobalControl((current_obj) => ({
      ...current_obj, video: {
        ...current_obj.video,
        play: !current_obj.video.play
      }
    }));

    if (videoR.paused) {
      wavesurfer?.play();
      videoR.play();
    } else {
      videoR.pause();
      wavesurfer?.playPause();
    }

    if (wavesurfer && wavesurfer.getDuration() < videoR.currentTime) {
      wavesurfer.setTime(wavesurfer.getDuration());
      wavesurfer.playPause();
    }
  };

  const [dataForm, setDataForm] = useState({
    title: '',
    description: '',
    video: { url: null, file: null },
    audio: { url: null, file: null }
  });

  const [globalControl, setGlobalControl] = useState({
    audio: {
      volume: {
        isOn: false,
        lvl: 1
      },
    },
    video: {
      play: false,
      volume: {
        isOn: false,
        lvl: 1
      },
      progress: 0,
      duration: 0
    }
  });

  const handleLoadedMetadata = () => setGlobalControl((current_obj) => ({ ...current_obj, video: { ...current_obj.video, duration: videoRef.current.duration } }));
  const handleTimeUpdate = () => {// Mientras el video se reproduce
    const [min, max] = rangeEdit;

    const duration = videoRef.current.duration;
    const tMin = duration / (100 / min);
    const tMax = duration / (100 / max);

    if (videoRef.current.currentTime < tMin || videoRef.current.currentTime > tMax) {
      const wavesurfer = waveSurferRef.current;

      videoRef.current.currentTime = tMin;
      setGlobalControl((current_obj) => ({ ...current_obj, video: { ...current_obj.video, progress: tMin } }));
      wavesurfer && wavesurfer.setTime(tMin < wavesurfer.getDuration() ? tMin : wavesurfer.getDuration());
    } else {
      setGlobalControl((current_obj) => ({ ...current_obj, video: { ...current_obj.video, progress: videoRef.current.currentTime } }));
    }
  }

  // cuando tocas/arrastras para cambiar el tiempo
  const handleSeek = (e) => {
    const time = Number(e.target.value);
    const [min, max] = rangeEdit;
    const videoR = videoRef.current;

    const duration = videoR.duration;
    const tMin = duration / (100 / min);
    const tMax = duration / (100 / max);

    if (tMin > time || tMax < time) {
      videoR.currentTime = tMin > time ? tMin : (tMax < time ? tMax : time);

      setGlobalControl((current_obj) => ({
        ...current_obj,
        video: {
          ...current_obj.video,
          progress: tMin > time ? tMin : (tMax < time ? tMax : time)
        }
      }));
    } else {
      videoR.currentTime = time;
      setGlobalControl((current_obj) => ({ ...current_obj, video: { ...current_obj.video, progress: time } }));
    }

    const wavesurfer = waveSurferRef.current;

    if (wavesurfer && wavesurfer.getDuration() >= videoR.currentTime) {
      wavesurfer.setTime(videoR.currentTime);

      if (videoR.paused && wavesurfer.isPlaying()) wavesurfer.playPause();
      if (!videoR.paused && !wavesurfer.isPlaying()) wavesurfer.play();
    } else {
      wavesurfer && wavesurfer.playPause()
      wavesurfer && wavesurfer.setTime(wavesurfer.getDuration());
    }
  };


  function searchFunction(e) {
    console.log("Se esta buscando:", e.target.value);
  }

  const returnView = useMemo(() => {
    switch (String(view ?? "").toLowerCase()) {
      case "":
        return <Main />;
      case "shorts":
        return <VideoHighWide type='high' />;
      case "long":
        return <VideoHighWide type='wide' />;
      case "favorites":
        return <VideoHighWide type='favorites' />;
      default:
        return <div>En construcción</div>;
    }
  }, [view]);

  const handleMultimediaChange = (e, type = 'video') => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setDataForm((current_data) => ({ ...current_data, [type]: { url: url, file: file } }));

      if (type == "video") {
        const wavesurfer = waveSurferRef.current;
        if (wavesurfer) {
          wavesurfer.setTime(0);
          wavesurfer.playPause();
        }
        setRangeEdit([0, 100]);

        setGlobalControl((current_obj) => ({
          ...current_obj, video: {
            play: false,
            volume: {
              isOn: false,
              lvl: 1
            },
            progress: 0,
            duration: 0
          }
        }));
        if (gainNodeRef.current) gainNodeRef.current.gain.value = 1;
      } else {
        setGlobalControl((current_obj) => ({
          ...current_obj, audio: {
            volume: {
              isOn: false,
              lvl: 1,
            },
          }
        }));
      }
    }
  };

  const styleControllers = {
    color: 'var(--backgroundColor-button-normal)',
    fontSize: '30px'
  }

  function handleVolumen(e, index = 0) {
    const field = ['video', 'audio'];
    const sf = index == 1 ? 0 : 1;

    setGlobalControl(prev => ({
      ...prev,
      [field[index]]: {
        ...prev[field[index]],
        volume: {
          ...prev[field[index]].volume,
          isOn: !prev[field[index]].volume.isOn
        }
      },
      [field[sf]]: {
        ...prev[field[sf]],
        volume: {
          ...prev[field[sf]].volume,
          isOn: false
        }
      }
    }));
  }

  function controlVolumen(e, type) {
    e.stopPropagation();
    const fVolume = Number(e.target.value);
    if (videoRef.current && type == 'video') {
      videoRef.current.volume = fVolume;
      if (gainNodeRef.current) gainNodeRef.current.gain.value = fVolume;
    }
    if (waveSurferRef.current && type == 'audio') waveSurferRef.current.setVolume(fVolume);

    setGlobalControl(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        volume: {
          ...prev[type].volume,
          lvl: fVolume
        }
      }
    }));
  }

  useEffect(() => {
    if (!containerRef.current || !dataForm.audio.url) return;
    const videoR = videoRef.current;

    waveSurferRef.current = WaveSurfer.create({
      url: API_URL + 'media/' + dataForm.audio.url,
      container: containerRef.current,
      waveColor: '#D9D9D9',
      progressColor: '#5B5B5B',
      cursorColor: '#5B5B5B',
      height: 20,
      barWidth: 2,
      barRadius: 2,
      responsive: true,
      autoplay: false,
      interact: false
    });

    waveSurferRef.current.once('ready', () => {
      if (waveSurferRef.current.getDuration() >= videoR.currentTime) {
        waveSurferRef.current.setTime(videoR.currentTime);
        if (!videoR.paused) waveSurferRef.current.playPause();
      }
      else {
        const wsf = waveSurferRef.current;
        wsf.setTime(wsf.getDuration());
        // console.log("Entro aqui 2");
        // waveSurferRef.current.playPause();
      }
    });

    return () => {
      // dataForm.audio.url && URL.revokeObjectURL(dataForm.audio.url);
      waveSurferRef.current?.destroy();
      waveSurferRef.current = null;
    };
  }, [dataForm.audio.url]);


  //   function changeTimeAudio() {
  //     const wavesurfer = waveSurferRef.current;
  //     const videoR = videoRef.current;

  //     if (videoR && wavesurfer) {
  //       else {
  //       wavesurfer.playPause();
  //       wavesurfer.setTime(0);
  //     }
  //   }
  //   console.log("Estado de musica 1.5: ", wavesurfer.isPlaying());
  // }


  function endVideo() {
    const wavesurfer = waveSurferRef.current;
    const videoR = videoRef.current;

    videoR.play();

    if (!wavesurfer) return;

    wavesurfer.setTime(0);
    wavesurfer.on(wavesurfer.play());
  }

  function removeAudio(e) {
    e?.stopPropagation();
    const wavesurfer = waveSurferRef.current;
    wavesurfer?.destroy();

    setDataForm((current_obj) => ({ ...current_obj, audio: { url: null, file: null } }));
  }

  // function setTimeEdit(e) {
  //   const newV = parseInt(e.target.value);
  //   if (newV < rangeEdit[0] || newV > rangeEdit[1]) return;
  //   setTimeRange(newV);

  //   const newTime = (videoRef.current.duration * newV) / 100;
  //   videoRef.current.currentTime = newTime;
  //   setGlobalControl((obj) => ({
  //     ...obj, video: {
  //       ...obj.video,
  //       progress: newTime
  //     }
  //   }))
  // }

  const getTime = (value) => {
    if (!videoRef.current) return 0;
    const duration = videoRef.current.duration;

    return duration / (100 / value);
  }

  function setRangeFunction(value) {
    const [r1, r2] = value;

    const min = getTime(r1);
    const max = getTime(r2);

    // console.log(`Duracion: ${duration}\nMinimo: ${duration / porc1}\nMaximo: ${duration / porc2}\nvalor aparte r1:${porc1} r2:${porc2}`);

    setGlobalControl((current_obj) => ({
      ...current_obj,
      video: {
        ...current_obj.video,
        progress: min > current_obj.video.progress ? min : (max < current_obj.video.progress ? max : current_obj.video.progress)
      }
    }));

    videoRef.current.currentTime = min > videoRef.current.currentTime ? min : (max < videoRef.current.currentTime ? max : videoRef.current.currentTime)

    setRangeEdit(value);
  }

  async function uploadVideo() {
    if(dataForm?.title.length<=3) return toast.info('Ingrese un titulo valido');
    if(!dataForm?.video.url) return toast.info('Video Obligatorio');
    
    setUploadState(true);
    const findAudio = audioList.find((obj) => obj?.url == dataForm?.audio.url);

    const formData = new FormData();
    const infoBody = {
      title: dataForm?.title ?? 'Ninguno',
      description: dataForm?.description ?? ''
    };

    const infoAudio = {
      audio_key: findAudio?.audio_key ?? 0,
      volume: globalControl.audio.volume.lvl
    };

    formData.append('data', JSON.stringify(infoBody));
    formData.append('video', dataForm.video.file);
    dataForm.audio.url && formData.append('audio', JSON.stringify(infoAudio));

    const bodyData = {
      ...globalControl,
      range: {
        ini: getTime(rangeEdit[0]),
        fin: getTime(rangeEdit[1])
      }
    };

    formData.append('metadata', JSON.stringify(bodyData));

    const fecthVideo = await CallApi({
      method: 'post',
      url: 'api/user/video',
      its_json: false,
      body: formData,
      showMessage: true
    });

    setUploadState(false);

    if (fecthVideo?.code != 200) return;

    removeAudio();
    setModalState(false);
    setRangeEdit([0, 100]);
    setSubModal(false);
    setAudioList([]);
    setDataForm({
      title: '',
      description: '',
      video: { url: null, file: null },
      audio: { url: null, file: null }
    });
    setGlobalControl({
      audio: {
        volume: {
          isOn: false,
          lvl: 1
        },
      },
      video: {
        play: false,
        volume: {
          isOn: false,
          lvl: 1
        },
        progress: 0,
        duration: 0
      }
    });

    const uk = userKey ?? 'me';// user key   
    const result = fecthVideo?.result ?? {};
    if (!userVideos?.[uk]?.[result?.type ?? 'none']) return;

    userVideos[uk][result.type] = [
      result,
      ...userVideos[uk][result.type]
    ];
  }

  function controlarVolumenCelular() {
    if (audioContextRef.current) return;
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const track = audioContext.createMediaElementSource(videoRef.current);
    const gainNode = audioContext.createGain();

    track.connect(gainNode).connect(audioContext.destination);

    audioContextRef.current = audioContext;
    gainNodeRef.current = gainNode;
  }

  const debouncedSearch = useCallback(
    debounce((item) => {
      const textSearch = String(item.target.value).toLowerCase();

      if (textSearch.length > 2) searchAudi(textSearch);
    }, 900),
    []
  );

  async function searchAudi(texto = null) {
    if (texto == null) return;
    setLoadState((current_data) => ({
      ...current_data,
      audio: true
    }));
    var resultFind;

    if (resultsAudio.current?.[texto]) {
      resultFind = resultsAudio.current[texto];
    } else {
      resultFind = await CallApi({
        url: 'api/user/video/audios?search=' + texto
      });

      resultsAudio.current[texto] = resultFind;
    }

    setAudioList(resultFind);

    setLoadState((current_data) => ({
      ...current_data,
      audio: false
    }));
  }

  function chooseAudio(url = null) {
    if (url == null) return;

    setDataForm((current_data) => ({
      ...current_data,
      audio: {
        ...current_data.audio,
        url: url
      }
    }));

    setSubModal(false);
  }

  const SubModalContent = () => {
    return (
      <>
        <h2>Biblioteca</h2>
        <form>
          <input type='text' placeholder='Buscar cancion' onChange={debouncedSearch} />

          <ul className='list_audio'>
            {
              loadState.audio ? (<Preloader />) : (
                audioList.length > 0 ? audioList.map((data) => (
                  <li>
                    <span>
                      <Note main_css={{ height: '50%' }} color='#FFFFFF' />
                    </span>

                    <div >
                      <p style={{ fontSize: '16px' }}>{data?.name ?? 'Sin Nombre'}</p>
                      <span style={{ fontSize: '14px' }}>{data?.owner ?? 'Unkown Artist'}</span>
                    </div>

                    <button type='button' className='default-buttons' onClick={() => chooseAudio(data.url)}>
                      Usar
                    </button>
                  </li>
                ))
                  : (
                    <li style={{ justifyContent: 'center' }}>Ningun audio encontrado</li>
                  )
              )
            }
          </ul>
        </form>
      </>
    );
  }

  return (
    <>
      <div className='sub-nav-user'>
        <div>
          <h1>Videos</h1>
          <button className='default-buttons selected' onClick={() => setModalState(true)}>Nuevo Video <AddCircleOutlineIcon className='small-icons' /></button>
        </div>

        <div>
          <div>
            <NavLink
              to={{ pathname: "/user/videos", search: locationReact.search }}
              end
              className={({ isActive }) =>
                "default-buttons" + (isActive ? " selected" : "")
              }
            >
              Todos
            </NavLink>

            <NavLink
              to={{ pathname: "/user/videos/shorts", search: locationReact.search }}
              className={({ isActive }) =>
                "default-buttons" + (isActive ? " selected" : "")
              }
            >
              Cortos
            </NavLink>

            <NavLink
              to={{ pathname: "/user/videos/long", search: locationReact.search }}
              className={({ isActive }) =>
                "default-buttons" + (isActive ? " selected" : "")
              }
            >
              Largos
            </NavLink>

            <NavLink
              to={{ pathname: "/user/videos/favorites", search: locationReact.search }}
              className={({ isActive }) =>
                "default-buttons" + (isActive ? " selected" : "")
              }
            >
              Favoritos
            </NavLink>
          </div>

          <div style={{ position: 'relative' }}>
            <button className='default-buttons' style={{
              backgroundColor: 'transparent',
              padding: '0px',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%) translateX(8px)'
            }}>
              <SearchIcon className='small-icons' style={{ color: 'var(--backgroundColor-button-normal)' }} />
            </button>
            <input type='search' placeholder='Buscar...' onChange={searchFunction} />
          </div>
        </div>
      </div>

      <div className='view-video-user'>
        {returnView}
      </div>

      {
        <ModalForAll sudChildren={SubModalContent} stateMiniModal={subModal} setStateMiniModal={() => setSubModal(false)} stateModal={modalState} setStateModal={setModalState} iconColor='var(--backgroundColor-button-normal)' styleButton={{ backgroundColor: 'var(--color-1)' }} className='modal-default modal-video-add' >
          <h2>Nuevo Video</h2>

          <form action='#'>
            <div>
              <label for="title_video">Título</label>
              <input id='title_video' type='text' value={dataForm?.title} placeholder='ej: Hosming aventuras' onChange={(e) => setDataForm((current_data) => ({
                ...current_data,
                title: e.target.value
              }))} />
            </div>

            <div>
              <label for="detail_video">Detalles</label>
              <DinamicTarea id='detail_video' description='Añadir detalles' valueT={dataForm.description} setValue={setDataForm} field='description' />
            </div>

            <div style={{ gap: '5px' }}>
              <label>Añadir Video</label>

              <div style={{
                position: 'relative',
                width: '100%',
                height: '350px',
                maxHeight: '600px',
                overflow: 'hidden',
                backgroundColor: 'var(--font-color-button)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '15px'
              }}>
                <input
                  ref={inputVideo}
                  type="file"
                  accept="video/*"
                  hidden
                  onChange={(e) => handleMultimediaChange(e, 'video')}
                />

                <input
                  ref={inputAudio}
                  type="file"
                  accept="audio/*"
                  hidden
                  onChange={(e) => handleMultimediaChange(e, 'audio')}
                />

                {
                  dataForm.video.url != null ? (<>
                    <video
                      ref={videoRef}
                      src={dataForm.video.url}
                      onLoadedMetadata={handleLoadedMetadata}
                      onTimeUpdate={handleTimeUpdate}
                      onEnded={() => endVideo()}
                      onPlay={controlarVolumenCelular}
                      style={{
                        width: '100%',
                        height: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                      playsInline
                      onClick={playVideo}
                    // loop <- Reproducir infinitamente
                    />
                    <button type='button' className='default-buttons' style={{ position: 'absolute', height: 'min-content', top: '10px', left: '10px', zIndex: 3 }} onClick={() => inputVideo.current && inputVideo.current.click()}>
                      <ChangeCircleIcon style={{ color: 'var(--theme-user)', fontSize: '35px' }} />
                    </button>
                  </>) : (
                    <button type='button' className='default-buttons' style={{ height: 'min-content', flexDirection: 'column', color: 'var(--color-fonts-modal)', fontSize: '14px' }} onClick={() => inputVideo.current && inputVideo.current.click()}>
                      <PictureIcon color='var(--color-fonts-modal)' main_css={{ width: '50px' }} />
                      Subir Video
                    </button>
                  )
                }
              </div>

              {
                dataForm.video.url != null && (
                  <div className='control-video'>
                    {
                      dataForm.video.url && (<>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                          <button type='button' className='default-buttons' style={{ height: 'min-content' }} onClick={playVideo}>
                            {globalControl.video.play ? <PauseIcon style={styleControllers} /> : <PlayArrowIcon style={styleControllers} />}
                          </button>

                          <button type='button' className='default-buttons' style={{ height: 'min-content' }} onClick={() => setMode((bool_value) => !bool_value)}>
                            <ContentCutIcon style={{ ...styleControllers, fontSize: '24px' }} />
                          </button>
                        </div>

                        <div className={mode ? 'edit-video' : 'control-video'}>
                          <input
                            className={mode ? 'range-video-edit' : 'range-control-video'}
                            type="range"
                            min="0"
                            max={globalControl.video.duration}
                            value={globalControl.video.progress}
                            step="0.1"
                            onChange={handleSeek}
                            onClick={(e) => e.stopPropagation()}
                          // onChange={handleSeekChange}
                          />
                          {
                            mode && (
                              <Slider
                                range
                                value={rangeEdit}
                                min={0}
                                pushable={5}
                                max={100}
                                onChange={setRangeFunction}
                                handleRender={(node, props) => {
                                  const { index } = props;

                                  return (
                                    <div
                                      {...node.props}
                                      style={{
                                        ...node.props.style,
                                        borderRadius: index === 0 ? '10px 0px 0px 10px' : '0px 10px 10px 0px',
                                        cursor: 'pointer',
                                      }}
                                    />
                                  );
                                }}
                                styles={{
                                  track: {
                                    backgroundColor: 'transparent',
                                    height: 45,
                                    cursor: 'pointer',
                                  },
                                  rail: {
                                    backgroundColor: 'transparent',
                                    height: 45,
                                  },
                                  handle: {
                                    marginTop: -4,
                                    borderColor: 'var(--backgroundColor-button-normal)',
                                    height: 45,
                                    width: 10,
                                    borderWidth: '1px',
                                    cursor: 'pointer',
                                    borderRadius: '10px 0px 0px 10px'
                                  },
                                }}
                              />
                            )
                          }
                        </div>

                        <button type='button' className='default-buttons' style={{ height: 'min-content', position: 'relative' }} onClick={(e) => handleVolumen(e, 0)}>
                          {
                            globalControl.video.volume.isOn && (
                              <input type='range'
                                className='range-control-video'
                                value={globalControl.video.volume.lvl}
                                min="0"
                                max="1.00"
                                step="0.01"
                                onChange={(e) => controlVolumen(e, 'video')}
                              />
                            )
                          }
                          {
                            globalControl.video.volume.lvl > 0.65 ? (<VolumeUpIcon style={styleControllers} />) : (
                              globalControl.video.volume.lvl > 0.32 ? (<VolumeDown style={styleControllers} />) : (<VolumeMuteIcon style={styleControllers} />)
                            )
                          }
                        </button>
                      </>
                      )
                    }
                  </div>
                )
              }

              <div className='control-video'>
                {
                  dataForm.audio.url && (
                    <button type='button' className='default-buttons' style={{ height: 'min-content' }} onClick={removeAudio}>
                      <DeleteIcon style={{ ...styleControllers, color: 'var(--empresa-color)' }} />
                    </button>
                  )
                }
                <div ref={containerRef} style={{ flex: '1' }} />

                {
                  dataForm.audio.url && (
                    <button type='button' className='default-buttons' style={{ height: 'min-content', position: 'relative' }} onClick={(e) => handleVolumen(e, 1)}>
                      {
                        globalControl.audio.volume.isOn && (
                          <input type='range'
                            className='range-control-video'
                            min="0"
                            max="1.00"
                            step="0.01"
                            value={globalControl.audio.volume.lvl}
                            onChange={(e) => controlVolumen(e, 'audio')}
                          />
                        )
                      }
                      {
                        globalControl.audio.volume.lvl > 0.65 ? (<VolumeUpIcon style={styleControllers} />) : (
                          globalControl.audio.volume.lvl > 0.32 ? (<VolumeDown style={styleControllers} />) : (<VolumeMuteIcon style={styleControllers} />)
                        )
                      }
                    </button>
                  )
                }
              </div>

            </div>

            {
              dataForm.video.url != null && (<button type='button' className='default-buttons' onClick={() => setSubModal((current_val) => !current_val)}><MusicNoteIcon className='very-small-icons' /> Agregar Audio</button>)
            }

            <ButtonLoader className='default-buttons' type='submit' state_progress={uploadState} onClick={uploadVideo}>
              Publicar
            </ButtonLoader>
          </form>
        </ModalForAll >
      }

      {
        <VideoViewer />
      }
    </>
  )
}
// inputAudio.current.click()
export default UserSubNavbar

/*
<div className='edit-video'>
              <input
                type='range'
                className='range-video-edit'
                min={0}
                max={100}
                step={1}
                value={timeRange}
                onChange={setTimeEdit}
                style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 1 }}
              />

              <Slider
                range
                value={rangeEdit}
                min={0}
                pushable={3}
                max={100}
                onChange={setRangeFunction}
                handleRender={(node, props) => {
                  const { index } = props;

                  return (
                    <div
                      {...node.props}
                      style={{
                        ...node.props.style,
                        borderRadius: index === 0 ? '10px 0px 0px 10px' : '0px 10px 10px 0px',
                        cursor: 'pointer',
                      }}
                    />
                  );
                }}
                styles={{
                  track: {
                    backgroundColor: 'transparent',
                    height: 45,
                    cursor: 'pointer',
                  },
                  rail: {
                    backgroundColor: 'transparent',
                    height: 45,
                  },
                  handle: {
                    marginTop: -4,
                    borderColor: 'var(--backgroundColor-button-normal)',
                    height: 45,
                    width: 10,
                    borderWidth: '1px',
                    cursor: 'pointer',
                    borderRadius: '10px 0px 0px 10px'
                  },
                }}
              />
            </div>
*/